// @Bass-Blocks-Integration: Removed polyfills because of ext dependency size. We can reintroduce if we want full IE compatibility.
// Polyfills because IE
// import 'core-js/es7/array';
// import 'core-js/es7/object';
// import 'react-app-polyfill/ie11';

/**
 * Entry point for both the BassBlocks library and the demo page
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import blocks, { BassBlockNameTypes } from './blocks';
import { setApiBase } from './config';

// Uncomment for debugging unnecessary renders
// import { whyDidYouUpdate } from 'why-did-you-update';
// if (process.env.NODE_ENV !== 'production') {
//   whyDidYouUpdate(React);
// }

/**
 * Attach any BassBlock to any DOM element with any props
 * @param el
 * @param block
 * @param props
 */
export const render = (
  el: string,
  block: BassBlockNameTypes,
  props: object
): void => {
  const domEl = document && document.getElementById(el);
  if (domEl) {
    const BassBlock: React.ReactType = blocks(block);
    ReactDOM.render(
      <React.StrictMode>
        <BassBlock {...props} />
      </React.StrictMode>,
      domEl
    );
  }
};

/**
 * Attach to window
 *
 * @example
 * window.bassBlocks.render(
 *   'react-app--final-results',
 *   'FinalResults',
 *   { tid: 1225 }
 * );
 */
(window as any).bassBlocks = {
  render,
  setApiBase,
};
